import { render, staticRenderFns } from "./SocialMediaHeader.vue?vue&type=template&id=e6b39bda&scoped=true&"
import script from "./SocialMediaHeader.vue?vue&type=script&lang=js&"
export * from "./SocialMediaHeader.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaHeader.vue?vue&type=style&index=0&id=e6b39bda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b39bda",
  null
  
)

export default component.exports